export const obstetricsAndGynecologyConst = {
  path: "/single-programs/obstetrics-and-gynecology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — АКУШЕРСТВО И ГИНЕКОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра, магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Акушерство и гинекология — на страже женского здоровья</h2>
      <p>
        Акушерство и гинекология — это ключевая область медицины, направленная на охрану женского здоровья на всех этапах жизни. Программа
        включает комплексное изучение репродуктивной системы, особенностей женской физиологии, ведения беременности, диагностики и лечения
        гинекологических заболеваний, родовспоможения и послеродового сопровождения.
      </p>
      <p>
        Будущие специалисты получают не только фундаментальные знания в области анатомии, биохимии и фармакологии, но и осваивают навыки
        клинической практики, УЗИ-диагностики, консультирования женщин и ведения беременности.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Женская анатомия и физиология</li>
        <li>Эндокринология и репродуктивная медицина</li>
        <li>Основы пренатальной диагностики</li>
        <li>Акушерские патологии и неотложная помощь при родах</li>
        <li>Гинекологические заболевания и методы их лечения</li>
        <li>УЗИ-диагностика в акушерстве и гинекологии</li>
        <li>Современные репродуктивные технологии и ЭКО</li>
        <li>Ведение беременности и послеродовое наблюдение</li>
        <li>Этика и психология общения с пациентами</li>
      </ul>
      <p>
        Обучение включает практику в клиниках, родильных домах и перинатальных центрах, а также участие в научных проектах и симуляционных
        тренингах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Акушер-гинеколог в частных и государственных клиниках</li>
        <li>Специалист по УЗИ-диагностике женского здоровья</li>
        <li>Репродуктолог в центрах планирования семьи и ЭКО</li>
        <li>Врач в женских консультациях и перинатальных центрах</li>
        <li>Научный сотрудник или преподаватель в области акушерства и гинекологии</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Женское здоровье — приоритетное направление медицины. Квалифицированные акушеры-гинекологи востребованы в любой стране.</p>
      <p>
        <strong>Средний доход в Европе составляет от €60,000 до €110,000 в год,</strong> с возможностью карьерного роста и частной практики.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Международный диплом бакалавра или магистра</li>
        <li>Программа на русском и английском языках</li>
        <li>Возможность очного или дистанционного обучения</li>
        <li>Стажировки в ведущих родильных домах и женских клиниках ЕС</li>
        <li>Доступ к современному симуляционному оборудованию</li>
        <li>Индивидуальное сопровождение студентов на всех этапах обучения</li>
      </ul>
      <h2>Учёба, приближенная к практике</h2>
      <p>
        Мы готовим специалистов, для которых женское здоровье — это не только профессия, но и призвание. Наши выпускники умеют заботиться,
        диагностировать, лечить и сопровождать женщин в самые важные моменты их жизни.
      </p>
      <br />
      <p className="padding-left">«Акушерство и гинекология — это искусство помогать жизни начинаться и сохраняться.»</p>
      <h2>Как поступить?</h2>
      <p>
        Заполните форму, прикрепите необходимые документы и дождитесь консультации приёмной комиссии. Мы поможем вам сделать первый шаг к
        профессии будущего.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра, магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Акушерство и гинекология — на страже женского здоровья
    Акушерство и гинекология — это ключевая область медицины, направленная на охрану женского здоровья на всех этапах жизни. Программа включает комплексное изучение репродуктивной системы, особенностей женской физиологии, ведения беременности, диагностики и лечения гинекологических заболеваний, родовспоможения и послеродового сопровождения.
    Будущие специалисты получают не только фундаментальные знания в области анатомии, биохимии и фармакологии, но и осваивают навыки клинической практики, УЗИ-диагностики, консультирования женщин и ведения беременности.

    Что вы будете изучать?
    • Женская анатомия и физиология
    • Эндокринология и репродуктивная медицина
    • Основы пренатальной диагностики
    • Акушерские патологии и неотложная помощь при родах
    • Гинекологические заболевания и методы их лечения
    • УЗИ-диагностика в акушерстве и гинекологии
    • Современные репродуктивные технологии и ЭКО
    • Ведение беременности и послеродовое наблюдение
    • Этика и психология общения с пациентами
    Обучение включает практику в клиниках, родильных домах и перинатальных центрах, а также участие в научных проектах и симуляционных тренингах.

    Кем можно работать после окончания?
    • Акушер-гинеколог в частных и государственных клиниках
    • Специалист по УЗИ-диагностике женского здоровья
    • Репродуктолог в центрах планирования семьи и ЭКО
    • Врач в женских консультациях и перинатальных центрах
    • Научный сотрудник или преподаватель в области акушерства и гинекологии

    Востребованность и доход
    Женское здоровье — приоритетное направление медицины. Квалифицированные акушеры-гинекологи востребованы в любой стране.
    Средний доход в Европе составляет от €60,000 до €110,000 в год, с возможностью карьерного роста и частной практики.

    Почему выбирают нас?
    • Международный диплом бакалавра или магистра
    • Программа на русском и английском языках
    • Возможность очного или дистанционного обучения
    • Стажировки в ведущих родильных домах и женских клиниках ЕС
    • Доступ к современному симуляционному оборудованию
    • Индивидуальное сопровождение студентов на всех этапах обучения

    Учёба, основанная на практике и эмпатии
    Мы готовим специалистов, для которых женское здоровье — это не только профессия, но и призвание. Наши выпускники умеют заботиться, диагностировать, лечить и сопровождать женщин в самые важные моменты их жизни.
    «Акушерство и гинекология — это искусство помогать жизни начинаться и сохраняться.»

    Как поступить?
    Заполните форму, прикрепите необходимые документы и дождитесь консультации приёмной комиссии. Мы поможем вам сделать первый шаг к профессии будущего.
  `,
};
